// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyDVouvE8CgjJWaml9ehp589BpGbWIsYr44',
  authDomain: 'kei-finance-dev.firebaseapp.com',
  projectId: 'kei-finance-dev',
  storageBucket: 'kei-finance-dev.appspot.com',
  messagingSenderId: '621291418342',
  appId: '1:621291418342:web:4d35774b3ee2b31d904127',
  measurementId: 'G-T175N4TF3Z',
};
